import { render, staticRenderFns } from "./numberIndex.vue?vue&type=template&id=4fcd5fbe&scoped=true"
import script from "./numberIndex.vue?vue&type=script&lang=js"
export * from "./numberIndex.vue?vue&type=script&lang=js"
import style0 from "./numberIndex.vue?vue&type=style&index=0&id=4fcd5fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd5fbe",
  null
  
)

export default component.exports